import type { CSSProperties, SVGProps } from 'react';

import { cx } from '../../lib/cx';
import styles from './Icon.module.css';
import { FILLED_ICONS, ICONS, type IconName } from './icons.generated';

export type { IconName };

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'children' | 'dangerouslySetInnerHTML'> {
  name: IconName;
  /** Lado en px (por defecto 20 px, el de `.ico`). */
  size?: number;
  /** Grosor del trazo (por defecto 1,75, el de `.ico`). */
  strokeWidth?: number;
  /**
   * Nombre accesible. Sin él, el ícono es decorativo (`aria-hidden`), como en el mockup: el texto
   * del botón o un `aria-label` en el control ya lo describen.
   */
  title?: string;
}

/**
 * Ícono del sprite, pintado en línea como `<svg class="ico">` del mockup: así heredan color, tamaño
 * y grosor del contexto (`.badge .ico`, `.navb a .ico`, estilos en línea).
 */
export function Icon({ name, size, strokeWidth, title, className, style, ...rest }: IconProps) {
  const sized: CSSProperties | undefined =
    size !== undefined || strokeWidth !== undefined
      ? { width: size, height: size, strokeWidth, ...style }
      : style;
  return (
    <svg
      viewBox="0 0 24 24"
      className={cx('ico', FILLED_ICONS.has(name) && styles.filled, className)}
      style={sized}
      focusable="false"
      {...(title ? { role: 'img', 'aria-label': title } : { 'aria-hidden': true })}
      {...rest}
      dangerouslySetInnerHTML={{ __html: ICONS[name] }}
    />
  );
}
